import TextAreaFormik from "@/common/components/form/TextAreaFormik";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { createPurchaseReturn } from "@/common/services/purchase-return.api";
import { IPurchaseOrderItem } from "@/types/purchaseOrder.types";
import { Modal } from "flowbite-react";
import { FormikProvider, useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";

type Props = {
  opened: boolean
  onClose?: () => void
  purchaseOrderId: string
  purchaseOrderDescription: string
  itensSelected: IPurchaseOrderItem[]
}

export default function ModalPurchaseReturnInfo({ opened, onClose, itensSelected, purchaseOrderId, purchaseOrderDescription }: Props) {

  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, notifySuccess } = useToastContext();

  const schema = Yup.object().shape({
    reason: Yup.string().required('O motivo é obrigatório').test('min-20', 'Razão tem que ter pelomenos 20 caracteres', value => (value as string).length > 20),
  });

  const formik = useFormik({
    validationSchema: schema,
    initialValues: {
      reason: '',
      returnRequestor: '',
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      const result = await createPurchaseReturn({
        purchaseOrderId,
        purchaseOrderDescription,
        reason: values.reason,
        products: itensSelected.map(item => ({
          description: item.description,
          productId: item.productId as string,
          qtd: item.qtd,
          value: String(item.value)
        }))
      });
      setIsLoading(false);

      if (result.ok) {
        notifySuccess("Criado devolução com sucesso");
      } else {
        notifyError(result.message as string);
      }
      if (onClose) onClose();
    },
  });

  return (
    <Modal show={opened} size="lg" onClose={onClose}>
      <FormikProvider value={formik}>
        <Modal.Header>
          Informações da Devolução
        </Modal.Header>
        <Modal.Body>
          <div className="space-y-6">
            {itensSelected.map(item => (
              <div key={item._id} className="p-4 border rounded">
                <p className="break-words font-semibold mb-2">Item: {item.description}</p>
                <p><strong>Quantidade:</strong> {item.qtd}</p>
                <p><strong>Preço Unitário:</strong> {item.value}</p>
              </div>
            ))}
          </div>

          <TextAreaFormik label="Descreva o motivo" className="mt-4 mb-9" name="reason"></TextAreaFormik>

        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-center">
            <ButtonWithLoader isLoading={isLoading} disabled={Object.keys(formik.errors).length ? true : false} onClick={formik.handleSubmit} className="bg-red-500 text-white px-4 py-2 rounded">
              Solicitar Devolução
            </ButtonWithLoader>
          </div>
        </Modal.Footer>
      </FormikProvider>

    </Modal>
  )
}